import { Component, OnInit } from '@angular/core';
import { MainFilterClass } from '../main-filter';

@Component({
  selector: 'app-date-filter',
  templateUrl: './date-filter.component.html',
  styleUrls: ['./date-filter.component.less'],
})
export class DateFilterComponent extends MainFilterClass  {
  // ngOnInit(): void {
  //     this.value = null;       
  //     this.firstValue = null;  
  //     this.secondValue = null; 
  //     this.hasError = false;   
  //     this.errorMessage = '';  
  //     this.onModelChange.emit(this.value);
  
  // }
  firstValue: any;
  secondValue: any;
  override onChange(value: any): void {
    if ([6, 7].includes(this.operator.operator)) {
      if (this.firstValue == null || this.secondValue == null) {
        this.errorMessage = 'Both inputs must have values';
        this.hasError = true;
        this.onModelChange.emit(null);
        return;
      }
      this.hasError = false;
      const firstDate = JSON.stringify(this.firstValue);
      const secondDate = JSON.stringify(this.secondValue);

      this.value = `${firstDate};${secondDate}`;
    } else {
      this.value = JSON.stringify(value);
    }
    this.onModelChange.emit(this.value);
  }
}
